import React from "react"
import "./loader.css"
import logo from "../../assets/images/logo.png" // transparent PNG or SVG

const Loader = () => {
  return (
    <div className="loader-main">
      <div className="logo-loader" style={{ "--logo-url": `url(${logo})` }} />
    </div>
  )
}

export default Loader
